import type { JSX } from "react";
import { useState } from "react";

import styled from "styled-components";

import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { useKeywordLists } from "app/modules/demand-analysis/keyword-lists";
import { allTrackers } from "app/services/track/track";

import { SearchTrendsConversionModal } from "../search-trends-page/SearchTrendsConversionModal";

const Wrapper = styled.div`
    margin-right: 12px;
`;

export const KeywordListsComparisonNavCallToAction = (): JSX.Element | null => {
    const [isSaveSearchTermModalOpen, setIsSaveSearchTermModalOpen] = useState(false);
    const { keywordLists } = useKeywordLists();
    const [primaryKeywordList, ...restKeywordLists] = keywordLists;
    const isCompareMode = restKeywordLists.length > 0;
    const primaryKeywordListType = primaryKeywordList.type;

    if (!isCompareMode && (primaryKeywordListType === "searchTerm" || primaryKeywordListType === "aiTopic")) {
        return (
            <>
                <Wrapper>
                    <IconButton
                        type="outlined"
                        iconName="add"
                        iconSize="xs"
                        onClick={() => {
                            allTrackers.dispatchTrackEvent("Button", "click", "save as list/click", {
                                KW_list_type: "search term",
                                KW_list_name: primaryKeywordList.name,
                            });

                            setIsSaveSearchTermModalOpen(true);
                        }}
                    >
                        {translate("keyword.analysis.subnav.search.term.save.button.text")}
                    </IconButton>
                </Wrapper>
                <SearchTrendsConversionModal
                    seed={primaryKeywordList.name}
                    type={primaryKeywordListType}
                    isOpen={isSaveSearchTermModalOpen}
                    onClose={() => setIsSaveSearchTermModalOpen(false)}
                />
            </>
        );
    }

    return null;
};
